import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  display: grid;
  grid-gap: 54px;
  align-items: center;
  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr;
  }
`

const InversedText = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 176.3%;
  color: var(--font-color);
  @media (min-width: ${breakpoints.medium}px) {
    grid-row: 1 / 2;
    grid-column: 2 / 3;
  }
`

const InversedImage = styled.div`
  @media (min-width: ${breakpoints.medium}px) {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
  }
`
const Text = styled.div`
  font-weight: 300;
  font-size: 16px;
  line-height: 176.3%;
  color: var(--font-color);
`

const ContentWithImage = ({ text, image, orientation }) => {
  if (orientation === "text_on_left") {
    return (
      <Wrapper>
        <Text>{text}</Text>
        <div>{image}</div>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <InversedText>{text}</InversedText>
      <InversedImage>{image}</InversedImage>
    </Wrapper>
  )
}

ContentWithImage.propTypes = {
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  orientation: PropTypes.oneOf(["text_on_left", "text_on_right"]),
}

ContentWithImage.defaultProps = {
  orientation: "text_on_left",
}

export { ContentWithImage }
